export default __webpack_public_path__ + "static/media/graphic-08.21835594.png";